import type { SiteData } from "../lib/types";

export const officialUrls = {
  doppler: "https://blog.doppler.finance/blog/xdp-genesis-airdrop-registration",
  dopplerApp: "https://app.doppler.finance/airdrop",
  limitless: "https://limitless.exchange/blog/points-season-4-announcement",
  limitlessBlog: "https://limitless.exchange/blog",
  apyxSeason: "https://blog.apyx.fi/season-2-is-here-new-multipliers-a-loyalty-boost-even-more-tokens-up-for-grabs/",
  apyxRisk: "https://blog.apyx.fi/apyx-2-0-redemption-value-total-collateralization-evolution-of-the-dividend-backed-dollar/",
  apyxRewards: "https://app.apyx.fi/rewards",
  risex: "https://blog.risechain.com/rise-points-season-1-ignite-everything-you-need-to-know/",
  risexPoints: "https://www.rise.trade/en/points",
  risexThirdParty: "https://decrypt.co/374238/risex-launches-ignite-season-1-points-program-following-3b-in-volume-during-the-early-access-phase",
  afxPr: "https://www.prnewswire.com/news-releases/afx-launches-mainnet-points-program-to-reward-real-traders-liquidity-providers-and-communities-302781086.html",
  afxPoints: "https://app.afx.xyz/points",
  afxDomain: "https://afx.com/",
} as const;

const verifiedAt = "2026-08-01T17:09:00+08:00";
const lastVerifiedAt = "2026-08-01 17:09 UTC+8";

export const siteData: SiteData = {
  meta: { verifiedAt, timezone: "Asia/Shanghai", dataVersion: "2026-08-01-v1", autoRefresh: false },
  disclaimer: "静态快照，不自动更新。信息与风险判断仅适用于 2026-08-01 17:09（Asia/Shanghai）核验时点，不构成投资建议或空投资格承诺。低风险不代表无风险。",
  projects: [
    {
      id: "doppler", slug: "doppler-xdp", name: "Doppler $XDP", sector: "XRP/RWA 基础设施",
      network: "Base + XRPL 计划", type: "已确认创世空投登记", opportunityScore: 90,
      riskScore: 22, confidenceScore: 94, burdenScore: 10, urgencyScore: 82, priorityScore: 82.3,
      rating: "A", hardStop: false,
      conclusion: "这是本轮唯一需要既有合资格用户立即检查的低资金负担事项；它不是新用户可补做的挖分机会。",
      evidenceBasis: "官方博客确认 $XDP Genesis Airdrop、合资格范围、Base 地址登记入口以及 TGE 时完全解锁。",
      unknowns: ["具体分配", "Tokenomics", "TGE 日期", "登记截止", "地区可用性"],
      tgeStatus: "unknown / 未公布", snapshotStatus: "DP Season 1/2 资格期已完成；正式快照未公布",
      deadline: "登记截止未公布", sourceIds: ["doppler-registration", "doppler-app"],
    },
    {
      id: "limitless", slug: "limitless", name: "Limitless Season 4", sector: "预测市场",
      network: "以官方界面为准", type: "已确认积分决定空投份额", opportunityScore: 84,
      riskScore: 48, confidenceScore: 90, burdenScore: 48, urgencyScore: 42, priorityScore: 59.4,
      rating: "B", hardStop: false,
      conclusion: "空投依据强、窗口仍长，但必须用真实资金交易预测市场；只适合本来就理解并愿意承担事件合约亏损的人。",
      evidenceBasis: "官方明确称积分决定即将到来的 Limitless token airdrop 份额。",
      unknowns: ["TGE", "代币分配比例", "估值", "Claim", "快照规则", "具体时区"],
      tgeStatus: "unknown / 未公布", snapshotStatus: "continuous / 持续统计",
      deadline: "2026-10-26，时区未注明", sourceIds: ["limitless-s4", "limitless-blog"],
    },
    {
      id: "apyx", slug: "apyx", name: "Apyx Season 2", sector: "稳定币/收益协议",
      network: "Ethereum、Base、BNB Chain 等", type: "已确认积分分配与 TGE", opportunityScore: 86,
      riskScore: 68, confidenceScore: 92, burdenScore: 82, urgencyScore: 48, priorityScore: 49.4,
      rating: "C", hardStop: false,
      conclusion: "分配和日期最清晰，但资金、脱锚、赎回、LP/借贷与期限风险显著；按保守画像只观察，不建议为积分新建仓位。",
      evidenceBasis: "Season 2 分配 6,000,000 APYX，占总供应 6%；Pips 决定份额。",
      unknowns: ["精确时区", "具体 Claim 流程", "地区/KYC", "TGE 是否会变更"],
      tgeStatus: "TGE/空投已确认：2026-10-13", snapshotStatus: "continuous / 持续统计",
      deadline: "Season 结束 2026-10-11", sourceIds: ["apyx-season-2", "apyx-redemption"],
    },
    {
      id: "risex", slug: "risex", name: "RISEx Ignite Season 1", sector: "链上永续合约交易所",
      network: "RISE", type: "官方积分；代币分配未确认", opportunityScore: 64,
      riskScore: 58, confidenceScore: 72, burdenScore: 60, urgencyScore: 30, priorityScore: 38.3,
      rating: "C", hardStop: false,
      conclusion: "这是刚启动的官方积分计划，但官方公告没有承诺积分兑换代币；永续合约风险高于当前证据强度，列观察而非主做。",
      evidenceBasis: "官方有持续积分、追溯早期用户和长期产品里程碑；第三方新闻稿称面向未来代币分配。",
      unknowns: ["官方代币", "空投", "积分兑换比例", "TGE", "社区分配", "快照"],
      tgeStatus: "unknown / 未公布", snapshotStatus: "continuous / 每周结算",
      deadline: "不晚于 2027 Q2，官方时间窗口", sourceIds: ["risex-ignite", "risex-token-claim"],
    },
    {
      id: "afx", slug: "afx", name: "AFX Points", sector: "永续合约/L1",
      network: "AFX", type: "身份链与状态冲突", opportunityScore: 72,
      riskScore: 78, confidenceScore: 35, burdenScore: 72, urgencyScore: 20, priorityScore: 25.5,
      rating: "D", hardStop: true,
      conclusion: "新闻稿、官网身份与积分页的 Season 状态无法互相一致，涉及交易和 Vault 资金，立即停止参与。",
      evidenceBasis: "PRNewswire 新闻稿、app.afx.xyz Points 页面与 afx.com 身份链存在无法消除的冲突。",
      unknowns: ["真正官方主域名", "当前 Season", "项目主体", "TGE", "合约", "资金托管", "地区规则"],
      tgeStatus: "unknown / 信息冲突", snapshotStatus: "changed / 信息冲突",
      deadline: "Season 1 新闻稿称 2026-07-20 结束，积分页称尚未开始",
      sourceIds: ["afx-pr", "afx-points", "afx-domain"],
    },
  ],
  tasks: [
    {
      id: "doppler-xdp-registration-20260801", projectId: "doppler", projectName: "Doppler Finance", type: "Eligibility / 地址登记", title: "$XDP Genesis Airdrop 地址登记",
      status: "confirmed / 官方确认且开放", description: "合资格 DP 持有人登记一个本人控制的 Base 网络地址。",
      purpose: "进入首批 $XDP Genesis Airdrop 分配。",
      eligibilityRelationship: "必须登记；登记本身不代表最终通过资格核验。",
      officialEntry: "Doppler 官方登记页", officialEntryUrl: officialUrls.dopplerApp, sourceLevel: "S",
      prerequisites: ["持有 DP 的原钱包", "本人控制的 Base EOA 地址"],
      supportedRegions: "未知；官方称部分司法辖区可能受限。", kyc: "未公布。",
      network: "Base（接收地址）；$XDP 计划同时部署于 Base 与 XRPL。",
      requiredAssets: "未发现官方要求新增资产；签名或 Gas 要求以登记界面为准。",
      walletGuidance: "原 DP 钱包 + 本人控制的 Base 专用小额钱包；不能使用交易所充值地址、合约地址或托管地址。",
      gas: "未知；不要在页面未明确说明前假定为零。", cost: "不应为登记额外投入资金。",
      lockup: "官方称合资格分配在 TGE 时完全解锁。", estimatedTime: "5—10 分钟。", frequency: "一次。",
      deadline: "未公布。", snapshotRelevance: "DP Season 1/2 与其他官方活动构成资格来源，最终规则待公布。",
      rewardStatus: "官方确认创世空投，最终资格与数量待核验。",
      steps: [
        "只从上述 Doppler 官方博客深链进入 app.doppler.finance/airdrop，逐字核对域名。",
        "连接持有 DP 的原钱包；阅读连接和签名内容，用户自行签名。若出现转账、Approve、Permit 或索要资产的请求，立即停止。",
        "填入本人控制的 Base EOA 地址；不要填交易所充值地址、智能合约地址或其他网络地址。",
        "再核对地址首尾字符和网络。官方称提交后不可修改，错误可能造成分配永久丢失。",
        "用户自行提交，保存页面确认结果、提交地址与时间。",
      ],
      verification: ["登记页显示成功状态；显示的 Base 地址与本人钱包完全一致。"],
      evidenceToKeep: ["成功页截图", "登记地址", "原 DP 钱包地址", "提交时间", "若有链上交易则保存交易哈希"],
      precautions: ["官方不会私聊索要连接钱包、转账、私钥或助记词；登记不代表最终获得分配。"],
      commonFailures: ["地址网络错误", "非本人控制地址", "页面域名错误", "钱包签名内容异常", "地区限制"],
      riskWarning: "最大风险是钓鱼与不可修改的错误接收地址，而不是 Gas 成本。",
      complianceNotes: "只使用本人合法控制的钱包；不规避地区限制或资格审查。",
      stopConditions: ["页面要求转账", "授权资产", "Permit", "下载未知软件", "提供秘密"],
      saferAlternative: "等待官方后续公告并只读核验地址。", lastVerifiedAt,
      minimumCostPath: "仅合资格用户完成一次地址登记，不新增资产交互。",
      standardPath: "完成登记后每周检查官方博客一次，等待截止、Tokenomics、Eligibility 与 TGE 公告。",
      advancedPath: "无。历史积分期已经结束，不建议为追溯资格新增无依据交互。",
      notRecommended: ["购买 DP", "向陌生地址付款", "使用第三方 Claim 页", "提交交易所充值地址"],
      investmentStopConditions: "出现非官方域名、资产授权/转账要求、地区不兼容或官方修改/取消活动。",
    },
    {
      id: "limitless-s4-minimum-volume", projectId: "limitless", projectName: "Limitless", type: "主网交易 / 积分", title: "Points Season 4 最低交易量",
      status: "confirmed / 官方确认进行中", description: "通过真实预测市场交易达到至少 200 美元累计交易量，以进入积分计划。",
      purpose: "累积决定空投份额的积分。",
      eligibilityRelationship: "200 美元交易量是官方最低门槛，但不代表有最低分配。",
      officialEntry: "Limitless Season 4 官方公告", officialEntryUrl: officialUrls.limitless, sourceLevel: "S",
      prerequisites: ["理解预测市场结算规则", "允许地区", "官方界面支持的钱包和资产"],
      supportedRegions: "本轮未在公告中确认；以最新条款与界面为准。", kyc: "本轮未确认。",
      network: "以官方界面显示为准，不从旧资料推断。", requiredAssets: "官方界面支持的结算资产；总损失上限必须先设定。",
      walletGuidance: "空投专用小额钱包。", gas: "未知，外加交易费用、点差与潜在全部本金损失。",
      cost: "官方门槛为 200 美元累计交易量；交易量不等于净投入。", lockup: "取决于所选市场的结算时间。",
      estimatedTime: "首次 20—40 分钟；后续按真实使用频率。", frequency: "无需机械高频；积分每周结算。",
      deadline: "2026-10-26，时区未注明。", snapshotRelevance: "持续统计；层级 2026-08-17 与 2026-09-14 重置，已赚积分不重置。",
      rewardStatus: "积分决定即将到来的代币空投份额；具体分配未公布。",
      steps: [
        "从官方公告进入 Limitless，核对 limitless.exchange 域名、市场结算条件和地区条款。",
        "只向专用小额钱包准备能承受损失的资产并保留 Gas；跨链若非必要则不做，必须跨链时只用官网所列桥并先小额测试。",
        "选择你能独立判断、结算来源清晰、流动性尚可的市场；不要为了积分交易不理解的事件。",
        "阅读下单金额、价格、最大亏损、手续费与结算规则；用户自行签名和广播。",
        "累计真实交易量达到 200 美元后，在官方积分页等待每周更新，不做对敲或机械刷量。",
      ],
      verification: ["官方页面显示积分或已达到计划门槛；链上/账户历史能对应真实订单。"],
      evidenceToKeep: ["订单记录", "交易哈希", "积分周结算截图", "市场结算规则"],
      precautions: ["交易量不是本金，也不是收益；错误判断可能损失全部下单金额。"],
      commonFailures: ["地区不支持", "市场已接近结算/流动性不足", "订单未成交", "积分周更新尚未发生", "误入仿冒域名"],
      riskWarning: "事件结果、预言/裁决、流动性、授权、跨链和价格波动风险均存在。",
      complianceNotes: "只做自然真实交易；不自成交、不循环资金、不批量地址或虚假邀请。",
      stopConditions: ["达到损失上限", "点差/费用异常", "规则不清", "市场争议", "官方改变空投映射"],
      saferAlternative: "仅观察周榜和公告。", lastVerifiedAt,
      minimumCostPath: "若本来就会使用预测市场，仅完成官方 200 美元累计交易量门槛；不为积分增加交易频率。",
      standardPath: "每周少量、真实、可解释的市场参与，并核对积分结算。",
      advancedPath: "官方还奖励流动性和邀请，但 LP 不符合当前保守画像，邀请只应面向真实愿意使用产品的人。",
      notRecommended: ["薄市场 LP", "为了积分追高频交易", "自成交", "借贷加杠杆", "使用不明桥或第三方机器人"],
      investmentStopConditions: "累计亏损/费用达到预设上限、积分稀释明显、空投规则变更、提现或结算异常、安全事件。",
    },
    {
      id: "apyx-s2-hold-apxusd", projectId: "apyx", projectName: "Apyx", type: "持币 / 积分", title: "Pips Season 2 持有 apxUSD",
      status: "confirmed / 进行中", description: "最低复杂度路径是持有 apxUSD，按日以 8x 倍率累计 Pips。",
      purpose: "分享 Season 2 的 6,000,000 APYX 分配。", eligibilityRelationship: "Pips 决定 Season 2 分配份额。",
      officialEntry: "Apyx 官方 Rewards", officialEntryUrl: officialUrls.apyxRewards, sourceLevel: "S",
      prerequisites: ["接受 apxUSD 抵押资产与赎回机制风险", "设定资金上限"], supportedRegions: "未知。", kyc: "未知。",
      network: "支持路径跨 Ethereum、Base、BNB Chain；具体持有路径以官方 Rewards 页为准。",
      requiredAssets: "获取 apxUSD 所需的官方支持资产及 Gas。", walletGuidance: "专用小额钱包。",
      gas: "依网络和路径而定；Ethereum 可能较高，另有滑点与赎回价差。", cost: "未知；预算未提供，因此不建议启动新仓位。",
      lockup: "普通 apxUSD 可卖出/赎回；Commit 路径官方写明 14 天解锁，apyUSD 页面写明 20 天解锁。",
      estimatedTime: "首次研究与操作 30—60 分钟；需持续监控价格和赎回值。", frequency: "每日累计，非机械交易。",
      deadline: "2026-10-11。", snapshotRelevance: "按持仓美元价值与倍率持续累计。",
      rewardStatus: "官方确认 6% 总供应用于 Season 2。",
      steps: [
        "先阅读 Season 2 公告和 Apyx 2.0 风险说明，确认你理解 apxUSD 不是银行存款，赎回值会随抵押篮子变化。",
        "从官方博客进入 Rewards，核对 apyx.fi 域名、网络、资产合约、兑换/赎回机制。",
        "若仍决定参与，只使用专用小额钱包和预设可损失金额；获取 apxUSD 涉及 Swap/Approve 时，核对精确授权额度、滑点和赎回值，用户自行签名。",
        "保留 Gas，不进入 Commit、LP、Pendle YT、借贷或循环杠杆路径。",
        "在官方 Rewards 页核对 Pips，并持续监控 apxUSD 二级价格、Redemption Value 与官方安全公告。",
      ],
      verification: ["Rewards 页显示持仓与 Pips；钱包余额、交易哈希和官方资产合约一致。"],
      evidenceToKeep: ["买入价", "赎回值", "交易哈希", "授权对象/额度", "Pips 截图"],
      precautions: ["高倍率不等于高净收益；脱锚、赎回价差、锁定、无常损失和清算可能超过潜在空投价值。"],
      commonFailures: ["合约/网络错误", "授权过大", "二级价格偏离赎回值", "Rewards 未识别支持仓位", "锁定/退出期限理解错误"],
      riskWarning: "官方披露 apxUSD 曾跌至约 0.90 美元；抵押物集中于数字资产财库公司优先股，存在价格和流动性风险。",
      complianceNotes: "不循环资金伪造 TVL，不用多地址机械仓位；遵守地区和活动规则。",
      stopConditions: ["apxUSD 再次明显偏离赎回值", "赎回受限", "审计/储备数据异常", "合约事件", "预算上限触发"],
      saferAlternative: "只读观察到 TGE。", lastVerifiedAt,
      minimumCostPath: "当前保守画像下为“只观察，不新增仓位”。若本来持有 apxUSD，仅核对 Rewards 是否正确累计。",
      standardPath: "仅在完成风险评估和预算设定后，小额持有 apxUSD；不追高倍路径。",
      advancedPath: "Commit、Curve LP、Pendle YT/LP、Morpho 借贷和 Vault 倍率更高，但不符合默认画像，不建议执行。",
      notRecommended: ["196x Commit", "LP", "YT", "借贷", "循环杠杆", "将主资产集中换成 apxUSD"],
      investmentStopConditions: "价格脱锚扩大、赎回价差异常、抵押物下跌、退出受限、安全事件、预期空投价值低于风险与费用。",
    },
    {
      id: "risex-ignite-s1-trading", projectId: "risex", projectName: "RISEx / RISE", type: "永续合约交易 / 积分", title: "Ignite Season 1 永续合约积分",
      status: "confirmed / 积分进行中；空投 unconfirmed", description: "以真实交易、持仓、流动性或邀请贡献参与每周积分分配。",
      purpose: "累积 RISEx Points；未来代币收益未由官方确认。", eligibilityRelationship: "只确认积分排名，不确认代币资格。",
      officialEntry: "RISEx 官方 Points", officialEntryUrl: officialUrls.risexPoints, sourceLevel: "积分 S；代币推断 B。",
      prerequisites: ["理解永续合约、保证金和清算", "允许地区", "官方支持资产"], supportedRegions: "未知。", kyc: "未知。",
      network: "RISE。", requiredAssets: "以官方交易界面为准。", walletGuidance: "专用小额钱包。",
      gas: "未知；另有手续费、资金费率、滑点和清算风险。", cost: "未知；官方没有最低门槛。",
      lockup: "持仓时间会影响积分，但不应为积分延长高风险仓位。", estimatedTime: "首次 30—60 分钟；每周核对一次。",
      frequency: "自然真实使用；权重每周变化且不公开。", deadline: "不晚于 2027 Q2。",
      snapshotRelevance: "持续累计、每周分配。", rewardStatus: "积分确认，代币/空投未确认。",
      steps: [
        "先从官方公告进入 rise.trade，阅读积分文档、交易风险和地区条款。",
        "若不能独立解释保证金、资金费率与清算价，则停止，不为积分开仓。",
        "若本来需要交易，只用专用小额钱包和可承受损失的保证金；任何存入、Approve 或跨链都核对网络、合约、额度和退出路线，用户自行签名。",
        "做真实、有明确目的的仓位；不为积分增加杠杆、持仓时间或机械交易。",
        "每周二 22:00（UTC+8）后检查 Points 页面；保留订单和积分记录。",
      ],
      verification: ["官方 Points 页面在周结算后显示积分，订单历史与链上记录一致。"],
      evidenceToKeep: ["入金/订单/出金记录", "交易哈希", "保证金与清算参数", "周积分截图"],
      precautions: ["评分权重每周变化且不公开，付出更多费用不一定得到更多积分。"],
      commonFailures: ["地区/网络不支持", "余额或保证金不足", "仓位被清算", "周结算未到", "Points 页面未正确关联钱包"],
      riskWarning: "杠杆、清算、预言机、合约、资金费率与跨链风险显著。",
      complianceNotes: "不洗量、不自成交、不用批量地址；官方明确强调有意图的真实交易高于机械流量。",
      stopConditions: ["需要高杠杆", "亏损/费用触顶", "提现异常", "官方仍不确认代币映射"],
      saferAlternative: "只读观察积分与产品里程碑。", lastVerifiedAt,
      minimumCostPath: "不新增交易；若本来就在 RISEx 真实交易，仅激活并核对 Points。",
      standardPath: "小额、低杠杆、真实使用，每周核对一次积分，不追逐隐藏权重。",
      advancedPath: "流动性和 Builder Code 等路径复杂且风险更高，不适合当前默认画像。",
      notRecommended: ["为了积分长时间持仓", "提高杠杆", "刷量", "自成交", "邀请无真实需求的用户"],
      investmentStopConditions: "亏损/费用触顶、清算风险上升、产品/桥/提现异常、积分稀释或官方长期不确认奖励映射。",
    },
  ],
  evidence: [
    { id: "doppler-registration", projectId: "doppler", claim: "登记开放，Season 2 结束，截止待公布", url: officialUrls.doppler, sourceName: "Doppler 官方公告", level: "S", publishedOrEventAt: "2026-07-20", status: "confirmed", lastVerifiedAt },
    { id: "doppler-app", projectId: "doppler", claim: "官方登记入口", url: officialUrls.dopplerApp, sourceName: "Doppler App", level: "S", publishedOrEventAt: "continuous", status: "confirmed", lastVerifiedAt },
    { id: "limitless-s4", projectId: "limitless", claim: "Season 4 时间、200 美元门槛、积分决定空投份额", url: officialUrls.limitless, sourceName: "Limitless 官方公告", level: "S", publishedOrEventAt: "发布 2026-06-12；活动 2026-05-25 至 2026-10-26", status: "confirmed", lastVerifiedAt },
    { id: "limitless-blog", projectId: "limitless", claim: "7 月仍持续发布产品更新", url: officialUrls.limitlessBlog, sourceName: "Limitless 官方博客", level: "S", publishedOrEventAt: "2026-07-31", status: "confirmed", lastVerifiedAt },
    { id: "apyx-season-2", projectId: "apyx", claim: "Season 2 分配、倍率、截止、TGE/空投日期", url: officialUrls.apyxSeason, sourceName: "Apyx 官方公告", level: "S", publishedOrEventAt: "发布 2026-05-19；Season 2026-05-23 至 2026-10-11", status: "confirmed", lastVerifiedAt },
    { id: "apyx-redemption", projectId: "apyx", claim: "apxUSD 曾跌至约 0.90 美元及赎回机制调整", url: officialUrls.apyxRisk, sourceName: "Apyx 2.0 官方说明", level: "S", publishedOrEventAt: "2026-06-15", status: "completed / 风险历史", lastVerifiedAt },
    { id: "risex-ignite", projectId: "risex", claim: "Ignite 开始、周分配、计分因素、Season 窗口", url: officialUrls.risex, sourceName: "RISE 官方公告", level: "S", publishedOrEventAt: "发布 2026-07-21；开始 2026-07-20 00:00 UTC", status: "confirmed", lastVerifiedAt },
    { id: "risex-token-claim", projectId: "risex", claim: "新闻稿称面向未来代币分配", url: officialUrls.risexThirdParty, sourceName: "Decrypt / Chainwire", level: "B", publishedOrEventAt: "2026-07-24", status: "third-party-estimate / 第三方表述", lastVerifiedAt },
    { id: "afx-pr", projectId: "afx", claim: "新闻稿称三季积分兑代币，Season 1 于 7 月 20 日结束", url: officialUrls.afxPr, sourceName: "PRNewswire", level: "B", publishedOrEventAt: "2026-05-25", status: "completed / 但身份链异常", lastVerifiedAt },
    { id: "afx-points", projectId: "afx", claim: "积分页称 Season 1 coming soon、开始日期 TBA", url: officialUrls.afxPoints, sourceName: "app.afx.xyz Points", level: "D", publishedOrEventAt: "抓取于 2026-07-28 前后", status: "information-conflict", lastVerifiedAt },
    { id: "afx-domain", projectId: "afx", claim: "新闻稿“官网”链接落到传统外汇/CFD 站", url: officialUrls.afxDomain, sourceName: "afx.com", level: "D", publishedOrEventAt: "当前页面", status: "information-conflict", lastVerifiedAt },
  ],
  events: [
    { id: "doppler-tge", projectId: "doppler", label: "TGE", dateOrWindow: "未公布", timezone: "未公布", localTime: "未公布", status: "unknown", sourceLevel: "S", sourceId: "doppler-registration", lastVerifiedAt },
    { id: "doppler-snapshot", projectId: "doppler", label: "快照", dateOrWindow: "正式快照未公布；DP Season 2 于 2026-07-20 结束", timezone: "未注明", localTime: "未注明", status: "completed / 资格期已完成", sourceLevel: "S", sourceId: "doppler-registration", lastVerifiedAt },
    { id: "doppler-deadline", projectId: "doppler", label: "登记截止", dateOrWindow: "稍后公布", timezone: "未公布", localTime: "未公布", status: "unknown", sourceLevel: "S", sourceId: "doppler-registration", lastVerifiedAt },
    { id: "limitless-tge", projectId: "limitless", label: "TGE", dateOrWindow: "未公布", timezone: "未公布", localTime: "未公布", status: "unknown", sourceLevel: "S", sourceId: "limitless-s4", lastVerifiedAt },
    { id: "limitless-weekly", projectId: "limitless", label: "快照", dateOrWindow: "持续累计；每周一更新并分发积分", timezone: "未注明", localTime: "未注明", status: "continuous", sourceLevel: "S", sourceId: "limitless-s4", lastVerifiedAt },
    { id: "limitless-end", projectId: "limitless", label: "Season 截止", dateOrWindow: "2026-10-26", timezone: "未注明", localTime: "日期不变，精确时刻未知", status: "official-window", sourceLevel: "S", sourceId: "limitless-s4", lastVerifiedAt },
    { id: "apyx-tge", projectId: "apyx", label: "TGE/空投", dateOrWindow: "2026-10-13", timezone: "未注明", localTime: "日期不变，精确时刻未知", status: "confirmed", sourceLevel: "S", sourceId: "apyx-season-2", lastVerifiedAt },
    { id: "apyx-daily", projectId: "apyx", label: "快照", dateOrWindow: "持仓按日累计 Pips", timezone: "未注明", localTime: "未注明", status: "continuous", sourceLevel: "S", sourceId: "apyx-season-2", lastVerifiedAt },
    { id: "apyx-season", projectId: "apyx", label: "Season 截止", dateOrWindow: "2026-10-11", timezone: "未注明", localTime: "日期不变，精确时刻未知", status: "confirmed", sourceLevel: "S", sourceId: "apyx-season-2", lastVerifiedAt },
    { id: "risex-tge", projectId: "risex", label: "TGE", dateOrWindow: "未公布", timezone: "未公布", localTime: "未公布", status: "unknown", sourceLevel: "S", sourceId: "risex-ignite", lastVerifiedAt },
    { id: "risex-weekly", projectId: "risex", label: "快照/分配", dateOrWindow: "每周二 14:00 UTC 分配积分", timezone: "UTC", localTime: "每周二 22:00 UTC+8", status: "continuous", sourceLevel: "S", sourceId: "risex-ignite", lastVerifiedAt },
    { id: "risex-end", projectId: "risex", label: "Season 截止", dateOrWindow: "不晚于 2027 Q2", timezone: "未注明", localTime: "未注明", status: "official-window", sourceLevel: "S", sourceId: "risex-ignite", lastVerifiedAt },
    { id: "afx-tge", projectId: "afx", label: "TGE", dateOrWindow: "未公布", timezone: "未公布", localTime: "未公布", status: "unknown / 信息冲突", sourceLevel: "B/D", sourceId: "afx-pr", lastVerifiedAt },
    { id: "afx-snapshot", projectId: "afx", label: "快照", dateOrWindow: "新闻稿称每周结算；页面显示未开始", timezone: "UTC/未知", localTime: "UTC+8/未知", status: "changed / 信息冲突", sourceLevel: "B/D", sourceId: "afx-points", lastVerifiedAt },
    { id: "afx-conflict", projectId: "afx", label: "Season 1", dateOrWindow: "新闻稿：2026-05-25 至 2026-07-20；积分页：coming soon / TBA", timezone: "ET/未知", localTime: "UTC+8/未知", status: "changed / 信息冲突", sourceLevel: "B/D", sourceId: "afx-pr,afx-points", lastVerifiedAt },
  ],
  watchlist: [
    { name: "Nansen", status: "noise-exclusion", reason: "官方明确 Nansen Points 不是代币，当前没有空投公告；不为未确认代币新增交易、订阅或质押。", url: "https://academy.nansen.ai/articles/8391652-about-nansen-points" },
    { name: "KAST", status: "noise-exclusion", reason: "可核验 Season 5 已于 2026-03-31 结束，未找到更新鲜的 Season 6 规则或 TGE 日期；涉及账户、KYC 与付费卡，不新增资金。", url: "https://www.kast.xyz/legal/airdrop" },
    { name: "MetaMask", status: "noise-exclusion", reason: "Season 1 与 Claim 已结束；不把 Rewards 更新推导为 MetaMask 原生代币空投。", url: "https://metamask.io/en-GB/news/introducing-metamask-rewards" },
  ],
};
